
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[urlname]/[openTab]",
      function () {
        return require("private-next-pages/user/[urlname]/[openTab]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[urlname]/[openTab]"])
      });
    }
  